/* WildYard Black Friday bundle landing page: countdown, finish swatches, sticky bar */
(function () {
  if (window.wyBf) return;
  window.wyBf = true;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function initCountdowns(root) {
    root.querySelectorAll('[data-wy-bf-countdown]').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var end = Date.parse(el.getAttribute('data-end'));
      var ended = el.parentNode.querySelector('[data-wy-bf-ended]');
      if (isNaN(end)) { el.hidden = true; return; }
      var nums = el.querySelectorAll('[data-unit]');
      var timer;
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) {
          el.hidden = true;
          if (ended) ended.hidden = false;
          clearInterval(timer);
          return;
        }
        var s = Math.floor(diff / 1000);
        var v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        nums.forEach(function (n) { n.textContent = pad(v[n.getAttribute('data-unit')]); });
      }
      tick();
      if (end > Date.now()) { el.hidden = false; timer = setInterval(tick, 1000); }
    });
  }

  function initCards(root) {
    root.querySelectorAll('[data-wy-bf-card]').forEach(function (card) {
      if (card.dataset.ready) return;
      card.dataset.ready = '1';
      var json = card.querySelector('[data-wy-bf-options]');
      if (!json) return;
      var options;
      try { options = JSON.parse(json.textContent); } catch (e) { return; }
      var swatches = card.querySelectorAll('[data-wy-bf-swatch]');

      function text(sel, val) {
        card.querySelectorAll(sel).forEach(function (n) { n.textContent = val; });
      }

      function select(i) {
        var o = options[i];
        if (!o) return;
        swatches.forEach(function (b, j) { b.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
        card.querySelectorAll('[data-wy-bf-colour-img]').forEach(function (img) {
          if (!o.img) return;
          img.removeAttribute('srcset');
          img.src = o.img;
          img.alt = o.alt || '';
        });
        card.querySelectorAll('[data-wy-bf-colour-thumb]').forEach(function (img) {
          if (!o.thumb) return;
          img.removeAttribute('srcset');
          img.src = o.thumb;
        });
        text('[data-wy-bf-finish-name]', o.label);
        text('[data-wy-bf-hint]', o.hint);
        text('[data-wy-bf-now]', o.price);
        text('[data-wy-bf-was]', o.compare);
        text('[data-wy-bf-save]', o.save);
        text('[data-wy-bf-item-price]', o.item_price);
        var input = card.querySelector('[data-wy-bf-variant]');
        if (input) input.value = o.id || '';
        var btn = card.querySelector('[data-wy-bf-submit]');
        if (btn) btn.disabled = !o.available;
        var now = card.querySelector('[data-wy-bf-buynow]');
        if (now) {
          if (o.id && o.available) { now.href = now.getAttribute('data-base') + o.id + ':1'; now.hidden = false; }
          else { now.hidden = true; }
        }
      }

      swatches.forEach(function (b, i) { b.addEventListener('click', function () { select(i); }); });
    });
  }

  function initSticky(root) {
    var bar = root.querySelector('[data-wy-bf-sticky]');
    if (!bar || bar.dataset.ready || !('IntersectionObserver' in window)) return;
    bar.dataset.ready = '1';
    var hero = document.querySelector('[data-wy-bf-hero]');
    var target = document.getElementById(bar.getAttribute('data-target'));
    var heroOut = !hero;
    var targetIn = false;
    function update() { bar.classList.toggle('is-visible', heroOut && !targetIn); }
    if (hero) new IntersectionObserver(function (e) { heroOut = !e[0].isIntersecting; update(); }).observe(hero);
    if (target) new IntersectionObserver(function (e) { targetIn = e[0].isIntersecting; update(); }, { threshold: 0.12 }).observe(target);
  }

  function init(root) {
    root = root || document;
    initCountdowns(root);
    initCards(root);
    initSticky(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
